module.exports = __webpack_public_path__ + "static/img/image_news_over_06.8b879e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_06.png
// module id = Qfv7
// module chunks = 10